module.exports = __webpack_public_path__ + "static/media/skip.5ea3fedd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/skip.png
// module id = 959
// module chunks = 0